import { defineComponent as _defineComponent } from 'vue';
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, resolveDirective as _resolveDirective, withCtx as _withCtx, createBlock as _createBlock, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
var _withScopeId = function (n) { return (_pushScopeId("data-v-349e4e85"), n = n(), _popScopeId(), n); };
var _hoisted_1 = ["src"];
import { ref } from 'vue';
import axios from 'axios';
export default /*#__PURE__*/ _defineComponent({
    __name: 'home-swipe',
    setup: function (__props) {
        var list = ref([]);
        axios({
            url: '/swiperList',
            method: 'get'
        }).then(function (res) {
            console.log(res.data.result);
            list.value = res.data.result;
        });
        return function (_ctx, _cache) {
            var _component_van_swipe_item = _resolveComponent("van-swipe-item");
            var _component_van_swipe = _resolveComponent("van-swipe");
            var _directive_lazy = _resolveDirective("lazy");
            return (_openBlock(), _createBlock(_component_van_swipe, {
                class: "my-swipe",
                autoplay: 3000,
                "indicator-color": "white"
            }, {
                default: _withCtx(function () { return [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(list.value, function (item) {
                        return _withDirectives((_openBlock(), _createBlock(_component_van_swipe_item, {
                            key: item.imgSrc
                        }, {
                            default: _withCtx(function () { return [
                                _createElementVNode("img", {
                                    src: item.imgSrc,
                                    alt: "欢迎来到哔哩哔哩"
                                }, null, 8, _hoisted_1)
                            ]; }),
                            _: 2
                        }, 1024)), [
                            [_directive_lazy, item]
                        ]);
                    }), 128))
                ]; }),
                _: 1
            }));
        };
    }
});
